// extracted by mini-css-extract-plugin
export default {"spinner":"LoadingScreen_spinner__HnmoL"};